import axios from './axios';

const PortfolioApi = {
    getByLocale: (locale) => axios.get(`/portfolios/locale/${locale}`),

    create: (formData) =>
        axios.post('/portfolios', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),

    update: (id, formData) =>
        axios.post(`/portfolios/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),

    remove: (id) => axios.delete(`/portfolios/${id}`),
};

export default PortfolioApi;
